import React, { useEffect, useContext, useMemo, useState } from 'react';
import { useIntl } from 'umi';
import { getStudioReportList } from '@home/services/competitor';
import { buriedPointGame, pointInter } from "@/pages/home/utils/buriedPoint";
import { StudioContext } from '@home/pages/studio/context';
import { dbhBtnLogMes, PageLogMes } from '@home/utils/buriedPointCfg';
import StudioState from '@home/pages/studio/components/StudioState';
import Loading from '@/pages/dashboard/components/Loadings';
import StudioReport from '@home/pages/studio/reports/components/StudioReport';
import SingleSelect from '@home/components/SingleSelect';
import { getName } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';
import { IS_GLOBAL } from '@home/_config/config';
import './index.scss';

const InsightsReport = () => {
  const { formatMessage, locale } = useIntl();
  const { currentGame, menuPermission } = useContext(StudioContext);
  const { unified_edition_id: gameId, studio_code: studioId } = currentGame || {};
  const [loading, setLoading] = useState(true);
  const [resData, setResData] = useState<{ resource_list: any[]; } | null>(null);
  const [selectValue, setSelectValue] = useState('create_time');

  const isEn = locale === LANGUAGE_EN;

  // report打点函数，增加studio信息
  const reportLogFn = (paramsObj: pointInter) => {
    buriedPointGame({gameName: currentGame?.game_name, ...paramsObj}, gameId, 'unified_id');
  };

  const segmentList = useMemo(() => [
    {
      id: "all",
      label: formatMessage({ id: 'dbh_studio_report_all' }),
      pagePoint: () => reportLogFn(PageLogMes?.studioReports),
    },
    {
      id: 'Marketing',
      label: formatMessage({ id: 'dbh_studio_report_general_gaming' }),
      pagePoint: () => reportLogFn(PageLogMes?.studioReportsMarketing),
    },
    {
      id: 'IN-Game Analytic',
      label: formatMessage({ id: 'dbh_studio_report_esports' }),
      pagePoint: () => reportLogFn(PageLogMes?.studioReportsInGame),
    }
  ], [formatMessage]);

  const controller = new AbortController();
  const getReportList = async (gameId: string, studioId: string) => {
    try {
      setLoading(true);
      const res = await getStudioReportList({
        studio_id: studioId,
        game_id: gameId,
        sorted_by: selectValue,
        desc: true
      }, { signal: controller.signal });
      

      const { resource_list: resourceList } = res;
      setResData({
        ...res,
        resource_list: resourceList.filter((item: any) => {
          if (IS_GLOBAL) {
            return item?.env !== 'woa';
          }
          return item?.env !== 'global';
        })
      });
      setLoading(false);
    } catch (err: unknown) {
      // @ts-ignore
      if (err?.msg === 'canceled') {
        // 如果是被取消，则恢复为初始态
        setLoading(true);
      } else {
        setLoading(false);
      }
      setResData(null);
    }
  };

  useEffect(() => {
    getReportList(gameId, studioId);
    reportLogFn(PageLogMes?.studioReports);
    return () => {
      controller.abort('页面离开，cancel调用');
      setResData(null);
    };
  }, [gameId, studioId, selectValue]);

  useEffect(() => () => {
    sessionStorage.removeItem('__dbh_studio_reports_data_brain_tab__');
  }, []);


  const rightNode = useMemo(() => <SingleSelect
    className='dbh-studio-reports-right-operate'
    options={[
      { value: 'create_time', text: getName(isEn, 'Date', '日期') },
      { value: 'watched_user_cnt', text: getName(isEn, 'View', '访问量') },
    ]}
    value={selectValue}
    onChange={setSelectValue}
    name={formatMessage({ id: 'dbh_studio_report_filter_sorting' })}
    searchable={false}
    listWidth={150}
    tooltip=''
  />, [isEn, selectValue, formatMessage]);

  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }

  const changeTab = (tab: any) => {
    if (tab.id !== 'DataBrain') {
      setSelectValue('create_time');
    }
  };

  // eslint-disable-next-line no-nested-ternary
  return loading ? (
    <Loading />
  ) : resData?.resource_list?.length ? (
    <StudioReport
      className={"dbh-studio-markets-report"}
      reportLogFn={reportLogFn}
      resData={resData}
      segmentList={segmentList}
      systemId={"studio"}
      studioId={studioId}
      gameId={gameId}
      searchType={'studioReportSearch'}
      pageLogMes={dbhBtnLogMes?.studioReportisSearch}
      rightOperateNode={rightNode}
      onTabChange={changeTab}
    />
  ) : <StudioState />;
};

export default InsightsReport;
